'use es6';

import styled from 'foundations-theming/utils';
import { Fragment } from 'react';
import { Tile } from 'foundations-components/transitional/components/Tile';
import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const __TileHandle = styled.div.withConfig({
  displayName: "SnowflakeFilterTile____TileHandle",
  componentId: "nzskfk-0"
})(["line-height:3px;height:12px;font-size:16px;text-align:center;user-select:none;&:hover{cursor:pointer;}"]);
const TileNumber = styled.div.withConfig({
  displayName: "SnowflakeFilterTile__TileNumber",
  componentId: "nzskfk-1"
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: theme.typography['heading-100'].fontWeight,
  padding: theme.space['300'],
  backgroundColor: theme.color['fill-surface-subtle'],
  borderRight: `1px solid ${theme.color['border-primary-default']}`
}));
const SnowflakeFilterTile = ({
  id,
  __isGrouped,
  readOnly,
  children,
  separator,
  showSeparator = false
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Tile, {
      "data-test-id": "filter-list-item",
      compact: true,
      readOnly: readOnly,
      distance: showSeparator ? 'extra-small' : 'small',
      backgroundColor: readOnly ? 'fill-primary-disabled' : 'fill-surface-default',
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "stretch",
        children: [id ? /*#__PURE__*/_jsx(TileNumber, {
          children: id
        }) : null, /*#__PURE__*/_jsx(Box, {
          flexGrow: "1",
          children: /*#__PURE__*/_jsx("div", {
            children: children
          })
        })]
      })
    }), showSeparator && separator]
  });
};
export default SnowflakeFilterTile;